import { User } from '../types';
import { apiFetch, setAuthToken } from './apiClient';
import { env } from './env';

type BackendLoginResponse = {
  token: string;
  teacher: {
    id: string;
    name: string;
    schoolId: string;
  };
};

export const isBackendAuthEnabled = (): boolean => Boolean(env.apiBaseUrl);

export async function loginTeacherWithBackend(
  schoolId: string,
  teacherId: string,
  pin: string,
): Promise<User> {
  const response = await apiFetch<BackendLoginResponse>('/v1/auth/login', {
    method: 'POST',
    body: JSON.stringify({
      schoolId: schoolId.trim(),
      teacherId: teacherId.trim(),
      pin,
    }),
  });

  setAuthToken(response.token);

  return {
    id: response.teacher.id,
    name: response.teacher.name,
    role: 'teacher',
    username: response.teacher.id,
    password: '',
    avatar: '👩‍🏫',
  };
}

export function logoutBackendSession(): void {
  setAuthToken(null);
}
